import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref } from 'vue';
// 注意：Hpsfir* 组件一律**不要手动 import**。
// 框架会把组件按 __name 全局注册，并且**主题会用自己的实现再注册一遍**
// （registerUiComponents → registerProComponents → registerThemeComponents，
//  同名后者覆盖前者）。手动 import 拿到的是基座/默认主题那份，
// 会绕过主题覆盖 —— 页面要用主题组件就只能靠全局注册。
// 这里只 import 非组件的东西：函数（message）、组合式函数、以及类型。
import type { HpsfirProTableColumn, HpsfirProTableFilter } from 'hpsfir-managebase-ui';
import { useApi } from '@/hooks/useApi';


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {


/**
 * 小程序用户（hpsfir-managebase-ui 1.0.0）。
 *
 * 只读列表：用户由小程序登录自动创建，后台不提供增删改。
 */
const api = useApi();
const loading = ref(false);

const columns: HpsfirProTableColumn[] = [
  {
    name: 'id',
    label: 'ID',
    type: 'string',
    hideCreate: true,
    hideEdit: true,
    width: 200,
  },
  {
    name: 'nickname',
    label: '昵称',
    type: 'string',
    isCondition: true,
    hideCreate: true,
    hideEdit: true,
  },
  {
    name: 'openid',
    label: 'openid',
    type: 'string',
    isCondition: true,
    hideCreate: true,
    hideEdit: true,
  },
  {
    name: 'phone',
    label: '手机号',
    type: 'string',
    isCondition: true,
    hideCreate: true,
    hideEdit: true,
  },
  {
    name: 'lastLoginTime',
    label: '最后登录',
    type: 'string',
    hideCreate: true,
    hideEdit: true,
  },
  {
    name: 'createTime',
    label: '注册时间',
    type: 'string',
    hideCreate: true,
    hideEdit: true,
  },
];

const getData = async(filter: HpsfirProTableFilter) => {
  loading.value = true;
  try {
    const keyword = filter.conditions?.openid
      || filter.conditions?.nickname
      || filter.conditions?.phone
      || undefined;
    const res: any = await api.searchTrackAdminApi.userPageSearchTrackAdmin(
      keyword,
      filter.paginations.page,
      filter.paginations.pageSize,
    );
    return {
      total: res?.data?.data?.total || 0,
      data: res?.data?.data?.data || [],
    };
  } finally {
    loading.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_HpsfirProPageHeader = _resolveComponent("HpsfirProPageHeader")!
  const _component_HpsfirProTable = _resolveComponent("HpsfirProTable")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_HpsfirProPageHeader, {
      title: "小程序用户",
      "title-en": "USER",
      description: "小程序端注册用户（用户 ID 为后台用户表主键，openid 仅作登录标识）"
    }),
    _createVNode(_component_HpsfirProTable, {
      ref: "tableRef",
      paginations: { pageSize: 10 },
      columns: columns,
      "get-data": getData,
      loading: loading.value,
      "hide-export": true
    }, null, 8, ["loading"])
  ]))
}
}

})